import { render, staticRenderFns } from "./BodyTable.vue?vue&type=template&id=4e060f34&scoped=true"
import script from "./BodyTable.vue?vue&type=script&lang=js"
export * from "./BodyTable.vue?vue&type=script&lang=js"
import style0 from "./BodyTable.vue?vue&type=style&index=0&id=4e060f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e060f34",
  null
  
)

export default component.exports